define('Home.ProductGallery.View', [
  'GlobalViews.Message.View',

  'home_productgallery.tpl',

  'Backbone',
  'SC.Configuration',
  'Utils',
  'jQuery',
  'underscore'
], function (
  GlobalViewsMessageView,
  home_productgallery_tpl,

  Backbone,
  Configuration,
  Utils,
  jQuery,
  _
) {
  'use strict';

  return Backbone.View.extend({
    template: home_productgallery_tpl,

    initialize: function (options) {
      this.galleries = Configuration.get('imagegallery');
      var self = this;

      jQuery(function () {
        if (self.galleries.galleries.length) {
          var firstGal = self.galleries.galleries[0];

          self.selectGallery(firstGal.code);
        }
      });
    },

    events: {
      'click .home-gallery-link': 'selectGallery',
      'click .home-gallery-image': 'openImage'
    },

    openImage: function (e) {
      var src = $(e.target).attr('src');

      var view = new GlobalViewsMessageView({
        message: '<img src="' + src + '"/>'
      });

      this.options.application.getLayout().showInModal(view);
    },

    selectGallery: function (e) {
      var code = e;
      if (e.target) {
        code = $(e.target).data('colorcode');
      }

      $('.home-gallery-image').each(function () {
        var imgcode = $(this).data('gallery');

        if (imgcode === code) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    },

    getContext: function () {
      return {
        hasGalleries: !!this.galleries.galleries.length,
        galleries: this.galleries.galleries,
        images: this.galleries.images
      };
    }
  });
});
